import { TextAreaField } from '@anm/components/form/fields';
import { flexCenter } from '@anm/styles/helpers';
import styled from 'styled-components';

export const ButtonsContainer = styled.div`
  ${flexCenter};
  a,
  button {
    margin: 10px;
  }
`;

export const DescriptionField = styled(TextAreaField)`
  textarea {
    min-height: 110px;
  }
`;
export const TagsField = styled(TextAreaField)`
  textarea {
    min-height: 134px;
  }
`;

const FormWrapper = styled.form`
  padding: 10px;
  max-width: 100vw;
  min-width: 900px;
  pointer-events: all;
  input,
  textarea {
    margin-bottom: 20px;
  }
`;

export default FormWrapper;
